// @flow

import type { FlatError } from '../../helpers/flattenError';

export type State = {|
  fetching: boolean,
  fetched: boolean,
  error: ?FlatError,
|};

export const initialState: State = {
  fetching: false,
  fetched: false,
  error: null,
};

export default null;
